export const enum ButtonFlag {
    Small = "small",
    WithoutPadding = "without_padding",
    With_icon = "with_icon",
    FullWidth = "full_width",
    /**
     * Used to span button to the whole parent.
     */
    FillParent = "fill_parent",
}

export const enum ButtonVariants {
    /**
     * Filled buttons are high-emphasis and describe actions that are primary to the app in the current context, so-called "call to action" buttons.
     * Filled button in neutral color scheme is the default button style.
     */
    Filled = "filled",
    /**
     * Ghost buttons are medium-emphasis buttons and describe actions that are less important in the current context.
     */
    Ghost = "ghost",
    /**
     * Inline buttons are used in text and are less prominent than the ghost buttons.
     * They are almost the same but without background even on hover.
     */
    Inline = "inline",
}

export const enum ButtonColorSchemes {
    Positive = "positive",
    Neutral = "neutral",
    Danger = "danger",
    Contrast = "contrast",
}
